import React, { FC } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { NEW_WINDOW_PROPS } from 'data/global';
import { links } from './data';
import { ReactComponent as ResolveLogoSvg } from 'icons/Resolve.svg';

import './SmallFooter.styles.scss';

type SmallFooterProps = {
  className?: string;
};

const SmallFooter: FC<SmallFooterProps> = ({ className }) => {
  const classes = classNames('small-footer', className);

  const { t } = useTranslation();

  return (
    <footer className={classes}>
      <ul className="small-footer__links">
        {links.map(({ href, label }) => (
          <li key={href}>
            <a href={href} aria-label={t(label)} {...NEW_WINDOW_PROPS}>
              {t(label)}
            </a>
          </li>
        ))}
      </ul>

      <a href="/" aria-label="Resolve logo" className="small-footer__logo">
        <ResolveLogoSvg />
      </a>
    </footer>
  );
};

export default SmallFooter;
